import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Twitter } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="dark-footer">
      <div className="footer-content">
        <div className="footer-section">
          <img src="/eaet-logo.svg" alt="EAET" style={{ height: '32px', marginBottom: '16px' }} />
          <p className="body-small" style={{ marginTop: '20px', maxWidth: '300px' }}>
            Leading platform for AI agent automation. Deploy intelligent agents to automate workflows and scale operations.
          </p>
          <div className="social-links">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <Twitter size={20} />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <Linkedin size={20} />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3 className="heading-3">Product</h3>
          <Link to="/industries">Industries</Link>
          <Link to="/platform">How It Works</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/demo">Book Demo</Link>
        </div>

        <div className="footer-section">
          <h3 className="heading-3">Company</h3>
          <Link to="/blog">Blog</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer-section">
          <h3 className="heading-3">Legal</h3>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <a href="#">Cookie Policy</a>
          <a href="#">Compliance</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="body-small">© 2022-2025, EAET LLC. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;